// eslint-disable-next-line
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {Typography} from "@mui/material";
import ProductCard from "./ProductCard";
import {generateCartItemsFrom} from "./Cart"
import SearchIcon from "@mui/icons-material/Search";
// eslint-disable-next-line
import {
  // eslint-disable-next-line
  CircularProgress,
  // eslint-disable-next-line
  Grid,
  // eslint-disable-next-line
  InputAdornment,
  // eslint-disable-next-line
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
// eslint-disable-next-line
import axios from "axios";
// eslint-disable-next-line
import { useSnackbar } from "notistack";
// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import Cart from "./Cart";
import { useHistory } from "react-router-dom";
// eslint-disable-next-line
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product

/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */
 


const Products = () => {

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   * 
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
   const history = useHistory();
   const { enqueueSnackbar } = useSnackbar();
   const [isLoading, setIsLoading] = useState(true);
   const [productsData, setProductsData] = useState([]);
   const [debounce, setDebounce] = useState(0);
   const username = localStorage.getItem("username");
   const [cart, SetCart] = useState([]);
   const [items, setItems] = useState([]);

  const token = localStorage.getItem("token");
   

  const performAPICall = async () => {
    try {
      const response = await axios.get(`${config.endpoint}/products`);
      setProductsData(response.data);
      setIsLoading(false);
      
      return response.data;
    } catch (err) {
      setIsLoading(false);
      enqueueSnackbar(err.response.data.message, { variant: "error" });
      console.log(err.response);
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (e) => {
    try {
      const url = `${config.endpoint}/products/search?value=${e.target.value}`;
      const response = await axios.get(url);
      console.log(response.data);
      setProductsData(response.data);
      return response.data;
    } catch (err) {
      if (err.response.status === 404) {
        setProductsData(err.response.data);
        console.log(err.response);
      }
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {
    let timeout;

    if (debounce) {
      clearTimeout(debounce);
    }

    timeout = setTimeout(() => performSearch(event), debounceTimeout);
    setDebounce(timeout);
  };

 useEffect(() => {
    (async function () {
      const dataFromProductAPI = await performAPICall();
      const dataForCart = await fetchCart(token);
      console.log(dataFromProductAPI);
      const DatainCart = await generateCartItemsFrom(dataForCart,dataFromProductAPI);
      setItems(DatainCart);
      
    })();
  }, []);


  const fetchCart = async (token) => {
    console.log('hi');
    if (!token)  return;

    try {
      console.log("hi")
     const url = `${config.endpoint}/cart`
      let res = await axios.get(url, {
        headers: {
          Authorization:`Bearer ${token}`
        }
        
      })
      SetCart(res.data);
      return res.data;
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };


  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
   const isItemInCart = (items, productId) => {
    return items.find((item) => {
      return item.productId === productId;
    });
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
   const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    try {
      if (!token) {
        enqueueSnackbar("Login to add an item to the Cart", {
          variant: "error",
        });
        return;
      }
      if (options.preventDuplicate) {
        if (isItemInCart(items, productId)) {
          enqueueSnackbar(
            "Item already in cart. Use the cart sidebar to update quantity or remove item.",
            { variant: "warning" }
          );
          return;
        }
      }
      const url = `${config.endpoint}/cart`;
      const itemToBeAdded = {
        productId,
        qty,
      };
      const response = await axios.post(url, itemToBeAdded, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      SetCart(response.data);
      const cartDetails = await generateCartItemsFrom(
        response.data,
        productsData
      );
      setItems(cartDetails);
    } catch (err) {
      if (err.response && err.response.status === 400) {
        enqueueSnackbar("Session has expired please login again!", {
          variant: "error",
        });
      }
    }

    
  };



  return (
    <div>
      

      <Header hasHiddenAuthButtons>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}

      </Header>

      {/* Search view for mobiles */}
      <Box className="search search-desktop">
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            // value={value}
            placeholder="Search for items/categories"
            InputProps={{
              endAdornment: <SearchIcon color="primary" />,
            }}
            onChange={(e) => debounceSearch(e, 500)}
          />
        </Box>

      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e) => debounceSearch(e, 500)}
      />

       <Grid container rowSpacing={1.5} >
        <Grid item md={username ? 8 : 12} lg={username ? 9 : 12}>
          <Grid item className="product-grid">
            <Box className="hero">
              <p className="hero-heading">
                India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
                to your door step
              </p>
            </Box>
          </Grid>
          {isLoading ? (
            <Box className="loading">
              <CircularProgress />
              <Typography variant="body2">Loading Products...</Typography>
            </Box>
          ) : productsData.length !== 0 ? (
            <Grid container rowSpacing={2.5} columnSpacing={2} my={2} px={2}>
              {productsData.map((product) => (
                <Grid item xs={6} md={3} key={product._id}>
                  <ProductCard
                    product={product}
                    handleAddToCart={(id, qty) =>
                      addToCart(token, cart, productsData, id, qty, {
                        preventDuplicate: true,
                      })
                    }
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box className="loading">
              <Typography variant="body2" color="textSecondary" mt={1}>
                No Products found 
              </Typography>
            </Box>
          )}
        </Grid>
        { username ? (<Grid item md={4} lg={3}>
          <Cart
              products={productsData}
              items={items}
              handleQuantity={(id, qty) =>
                addToCart(token, cart, productsData, id, qty)
              }
              // handleQuantity={addToCart}
            />
        </Grid>):null}
      </Grid>
      <Footer />
    </div>
  );
};

export default Products;
